// Ferdaus — JS propio de las secciones. Vanilla, sin librerias externas.

function initRevealObserver() {
  const els = document.querySelectorAll('.fer-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('fer-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.ferDelay || 0;
          setTimeout(() => entry.target.classList.add('fer-visible'), Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el) => observer.observe(el));
}

function initContadores() {
  const els = document.querySelectorAll('.fer-contador');
  if (!els.length) return;
  const anima = (el) => {
    const fin = Number(el.dataset.fin || 0);
    const dur = 1400;
    const inicio = performance.now();
    function paso(ahora) {
      const progreso = Math.min((ahora - inicio) / dur, 1);
      const valor = Math.round(fin * (1 - Math.pow(1 - progreso, 3)));
      el.textContent = valor.toLocaleString('es-ES');
      if (progreso < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        anima(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });
  els.forEach((el) => observer.observe(el));
}

function initMarquesina() {
  document.querySelectorAll('.fer-marquesina').forEach((wrap) => {
    const track = wrap.querySelector('.fer-marquesina-track');
    if (!track || track.dataset.duplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.duplicado = '1';
  });
}

function initAcordeon() {
  document.querySelectorAll('.fer-faq-item').forEach((item) => {
    const btn = item.querySelector('.fer-faq-pregunta');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const abierto = item.classList.contains('fer-faq-abierto');
      item.closest('.fer-faq').querySelectorAll('.fer-faq-item').forEach((i) => i.classList.remove('fer-faq-abierto'));
      if (!abierto) item.classList.add('fer-faq-abierto');
    });
  });
}

function initGaleriaFlip() {
  const visores = document.querySelectorAll('.fer-flip-galeria');
  if (!visores.length) return;

  function fotosDelColor(fuente, color) {
    const normalizado = (color || '').trim().toLowerCase();
    const elementos = Array.from(fuente.querySelectorAll('[data-fer-color]'));
    const conImagen = (el) => el.querySelector('img');
    // Algunos productos traen, por color, ademas del frente y la espalda,
    // una foto combinada "frente+espalda" y fotos de perfil (izquierda /
    // derecha) que aqui no interesan — nos quedamos solo con frente/espalda.
    const esFotoDeSobra = (el) => {
      const img = el.querySelector('img');
      const url = ((img && (img.currentSrc || img.src)) || '').toLowerCase();
      return url.includes('front-and-back') || url.includes('-left-') || url.includes('-right-');
    };
    let coincidencias = elementos.filter((el) => {
      const valor = (el.dataset.ferColor || '').trim().toLowerCase();
      return valor === normalizado;
    }).filter(conImagen).filter((el) => !esFotoDeSobra(el));
    // Si ningun color coincide (fotos sin etiquetar, primera carga sin
    // variante todavia resuelta...), mejor enseñar todo lo que haya que
    // dejar el visor vacio.
    if (!coincidencias.length) coincidencias = elementos.filter(conImagen).filter((el) => !esFotoDeSobra(el));
    return coincidencias.map((el) => {
      const img = el.querySelector('img');
      return { src: img.currentSrc || img.src, alt: img.alt || '' };
    });
  }

  function montar(visor) {
    const fuente = document.getElementById(visor.dataset.ferSource);
    if (!fuente) return;
    const imagen = visor.querySelector('.fer-flip-imagen');
    const prev = visor.querySelector('.fer-flip-flecha--prev');
    const next = visor.querySelector('.fer-flip-flecha--next');
    const contador = visor.querySelector('.fer-flip-contador');
    const botonZoom = visor.querySelector('.fer-flip-zoom-boton');
    const modal = visor.querySelector('.fer-flip-modal');
    const modalImagen = visor.querySelector('.fer-flip-modal-imagen');
    const modalCerrar = visor.querySelector('.fer-flip-modal-cerrar');
    const modalPrev = visor.querySelector('.fer-flip-modal-flecha--prev');
    const modalNext = visor.querySelector('.fer-flip-modal-flecha--next');
    let fotos = [];
    let indice = 0;

    function render() {
      const foto = fotos[indice];
      if (!foto) return;
      imagen.src = foto.src;
      imagen.alt = foto.alt;
      const varias = fotos.length > 1;
      prev.hidden = !varias;
      next.hidden = !varias;
      if (contador) contador.textContent = varias ? (indice + 1) + ' / ' + fotos.length : '';
      if (modal && !modal.hidden) {
        modalImagen.src = foto.src;
        modalImagen.alt = foto.alt;
        if (modalPrev) modalPrev.hidden = !varias;
        if (modalNext) modalNext.hidden = !varias;
      }
    }

    function cargar(color) {
      fotos = fotosDelColor(fuente, color);
      indice = 0;
      render();
    }

    function mover(delta) {
      if (fotos.length < 2) return;
      indice = (indice + delta + fotos.length) % fotos.length;
      render();
    }

    prev.addEventListener('click', () => mover(-1));
    next.addEventListener('click', () => mover(1));

    if (botonZoom && modal) {
      const abrir = () => {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        render();
        modalCerrar.focus();
      };
      const cerrar = () => {
        modal.hidden = true;
        document.body.style.overflow = '';
        botonZoom.focus();
      };
      botonZoom.addEventListener('click', abrir);
      imagen.addEventListener('click', abrir);
      modalCerrar.addEventListener('click', cerrar);
      modal.addEventListener('click', (e) => {
        if (e.target === modal) cerrar();
      });
      document.addEventListener('keydown', (e) => {
        if (modal.hidden) return;
        if (e.key === 'Escape') cerrar();
        if (e.key === 'ArrowLeft') mover(-1);
        if (e.key === 'ArrowRight') mover(1);
      });
      if (modalPrev) modalPrev.addEventListener('click', () => mover(-1));
      if (modalNext) modalNext.addEventListener('click', () => mover(1));
    }

    visor.ferCargar = cargar;

    const colorInicial = document.querySelector('variant-selects input[data-option-name="Color" i]:checked');
    cargar(colorInicial ? colorInicial.value : null);

    // Cuando Dawn sustituye la galería tras un cambio de variante (fetch),
    // recargamos las fotos del color que quede seleccionado.
    const observer = new MutationObserver(() => {
      const seleccionado = document.querySelector('variant-selects input[data-option-name="Color" i]:checked');
      cargar(seleccionado ? seleccionado.value : null);
    });
    observer.observe(fuente, { childList: true, subtree: true });
  }

  visores.forEach(montar);

  // Delegación: los inputs de color se reemplazan en cada cambio de
  // variante, así que escuchamos en document en vez de en cada input.
  document.addEventListener('change', (event) => {
    const input = event.target.closest('variant-selects input[data-option-name="Color" i]');
    if (!input || !input.checked) return;
    visores.forEach((visor) => {
      if (typeof visor.ferCargar === 'function') visor.ferCargar(input.value);
    });
  });
}

function initHeroCarrusel() {
  document.querySelectorAll('.fer-hero-carrusel').forEach((carrusel) => {
    const slides = Array.from(carrusel.querySelectorAll('.fer-hero-slide'));
    if (slides.length < 2) return;

    let indice = slides.findIndex((s) => s.classList.contains('is-active'));
    if (indice < 0) indice = 0;
    let temporizador = null;
    const reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const velocidad = (Number(carrusel.dataset.ferVelocidad) || 4) * 1000;

    function mostrar(nuevoIndice) {
      slides[indice].classList.remove('is-active');
      indice = (nuevoIndice + slides.length) % slides.length;
      slides[indice].classList.add('is-active');
    }

    function reiniciarAutoplay() {
      if (reducirMovimiento) return;
      if (temporizador) clearInterval(temporizador);
      temporizador = setInterval(() => mostrar(indice + 1), velocidad);
    }

    const prev = carrusel.querySelector('.fer-hero-flecha--prev');
    const next = carrusel.querySelector('.fer-hero-flecha--next');
    if (prev) {
      prev.addEventListener('click', (e) => {
        e.preventDefault();
        mostrar(indice - 1);
        reiniciarAutoplay();
      });
    }
    if (next) {
      next.addEventListener('click', (e) => {
        e.preventDefault();
        mostrar(indice + 1);
        reiniciarAutoplay();
      });
    }

    reiniciarAutoplay();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initRevealObserver();
  initContadores();
  initMarquesina();
  initAcordeon();
  initGaleriaFlip();
  initHeroCarrusel();
});
